import { IAccountBillContentBlock, IBillContent } from './type';
import { toWords, toWordsUSD } from '@/utils/transactionbill/toWordsConfig';
import useAppData from '@/hooks/useAppData';
import { VoucherBill } from './voucher';
import { Image } from 'antd';
import currencyFields from './currenyFields';

interface Props {
  blockProps: IAccountBillContentBlock;
  scaleFactor?: number;
  maxWidth: number;
  priceShow?: number;
  loopLength?: number;
  config?: any;
}

interface Props {
  blockProps: IAccountBillContentBlock;
  scaleFactor?: number;
  maxWidth: number;
  priceShow?: number;
  loopLength?: number;
  config?: any;
}

export type VoucherRow = {
  ledgerName: string;
  debitAmount: string | number;
  creditAmount: string | number;
  remarks?: string;
};

export const AccountBillContentBlock: React.FC<Props> = (props) => {
  const { blockProps, scaleFactor = 1, maxWidth, config } = props;
  const minHeight =
    config?.height - config?.header?.height - config?.footer?.height;

  const { data, type, currencyType } = blockProps;
  const columns = data?.column_name || [];

  const tableHeaderBgColor = data?.tableHeaderBgColor ?? 'none';
  const borderColor = data?.borderColor ?? '#000000';
  const headerTextColor = data?.headerTextColor ?? '#000000';
  const showGoldRate = data?.showGoldRate ?? false;
  const showTableFooter = data?.showTableFooter ?? true;
  const columnsGoldRateInTola = data?.columnsGoldRateInTola ?? false;
  const showReceiptDetails = data?.showReceiptDetails ?? false;
  const showPaymentDetails = data?.showPaymentDetails ?? false;

  const salesReceiptVoucherData = data?.voucherData;
  const salesReceiptVoucherEntries =
    salesReceiptVoucherData?.voucherEntries || [];

  // const headerBorderColor = data?.headerBorderColor ?? '#000000';

  const footerColumns = data?.table_footer_names || [];

  const footerRightColumns = data?.table_footer_right_columns || [];
  const caption = blockProps?.data?.amount_in_words_caption;
  const isVisibleColumns = [
    ...columns,
    ...(columnsGoldRateInTola
      ? [
          {
            key: 'Gold Rate (Tola)',
            dataIndex: 'goldRateInTola',
            isVisible: true,
            order: 3,
            width: 100,
          },
        ]
      : []),
  ].filter((column) => column?.isVisible);
  const totalVisibleWidth = isVisibleColumns?.reduce(
    (sum, col) => sum + Number(col?.width || 0),
    0,
  );

  const updatedVoucherData = data?.voucherData?.voucherEntries
    ?.filter((detail) => parseFloat(detail.creditAmount.toString()) === 0)
    .map((detail, index) => {
      return {
        key: index,
        receiveTo: detail.ledgerId,
        remarks: detail.remarks ? detail.remarks : '',
        amount: parseFloat(detail.debitAmount.toString()),
      };
    });

  const leftCellWidth =
    totalVisibleWidth -
    isVisibleColumns
      .slice(-3)
      .reduce((sum, col) => sum + Number(col?.width || 0), 0);

  // const rightCellWidth = totalVisibleWidth - leftCellWidth;

  const { app } = useAppData();

  const goldRateInTola = () => {
    if (!data?.goldAmount) return 0;
    if (app?.primaryCalculationType === 'gram')
      return (data?.goldAmount * 11.664).toFixed(3);
    if (app?.primaryCalculationType === 'lal')
      return (data?.goldAmount * 100).toFixed(3);
    return 0;
  };

  const voucherData: any[] = data?.voucherEntries || [];

  const rawTotals = voucherData.reduce(
    (acc, entry) => {
      const debit = Number(entry.debitAmount ?? 0);
      const credit = Number(entry.creditAmount ?? 0);

      acc.debitAmount += isNaN(debit) ? 0 : debit;
      acc.creditAmount += isNaN(credit) ? 0 : credit;
      return acc;
    },
    { debitAmount: 0, creditAmount: 0 },
  );

  const totals = {
    debitAmount: rawTotals.debitAmount,
    creditAmount: rawTotals.creditAmount,
  };

  const voucherData2: VoucherRow[] = [
    {
      ledgerName: '',
      debitAmount: Number(totals.debitAmount ?? 0)?.toFixed(2),
      creditAmount: Number(totals.creditAmount ?? 0)?.toFixed(2),
    },
  ];

  const columnsT: {
    key: string;
    width: number;
    dataIndex: keyof VoucherRow;
    remarks: string;
  }[] = [
    { key: 'Account Name', width: 40, dataIndex: 'ledgerName', remarks: '' },
    { key: 'Dr [NPR]', width: 20, dataIndex: 'debitAmount', remarks: '' },
    { key: 'Cr [NPR]', width: 20, dataIndex: 'creditAmount', remarks: '' },
    {
      key: 'remarks',
      width: 30,
      dataIndex: 'remarks',
      remarks: '',
    },
  ];

  const calculatedGoldRate =
    Number(goldRateInTola() || 0) || data?.goldAmount?.toLocaleString() || 0;

  const modifiedData = data?.items?.map((item: any, index: number) => {
    return {
      ...item,
      goldRateInTola: index === 0 ? '$ ' + calculatedGoldRate : '',
    };
  });

  return (
    <>
      {type === 'receipt' || type === 'payment' ? (
        <VoucherBill
          blockProps={blockProps}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
          config={config}
        />
      ) : type === 'journal' || type === 'contra' ? (
        <div
          style={{
            width: maxWidth,
            fontSize: config?.default_font_size || 12,
            minHeight: minHeight - 25,
            fontFamily: config?.default_font_family || 'Arial',
            display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',

            flexDirection: 'column',
            // borderLeft: `1px solid ${borderColor}`,
            // borderRight: `1px solid ${borderColor}`,
            borderBottom: `1px solid ${borderColor}`,
            borderTop: `1px solid ${borderColor}`,

            borderCollapse: 'collapse',
          }}
        >
          {(type === 'contra' || type === 'journal') && (
            <div>
              <div
                style={{
                  padding: '7px 0px',
                  textAlign: 'center',
                  width: '100%',
                  fontWeight: 600,
                  fontSize: 14,
                  borderLeft: `1px solid ${borderColor}`,
                  borderRight: `1px solid ${borderColor}`,
                }}
              >
                {type === 'contra'
                  ? 'Contra Voucher'
                  : type === 'journal'
                    ? 'Journal Voucher'
                    : 'Voucher Title'}
              </div>
              <div
                style={{
                  display: 'table',
                  width: '100%',
                  borderCollapse: 'collapse',
                }}
              >
                <div
                  style={{
                    display: 'table-row',
                    backgroundColor: tableHeaderBgColor,
                    borderTop: `1px solid ${borderColor}`,
                  }}
                >
                  {[
                    {
                      key: 'Particulars',
                      width: 40,
                      dataIndex: 'ledgerName',
                    },
                    { key: 'Debit', width: 20, dataIndex: 'debit' },
                    { key: 'Credit', width: 20, dataIndex: 'credit' },
                    {
                      key: 'Short Narration',
                      width: 30,
                      dataIndex: 'remarks',
                    },
                  ].map((column) => (
                    <div
                      key={column.key}
                      style={{
                        display: 'table-cell',
                        width: `${Number(column?.width || 0)}%`,
                        padding: '7px',
                        borderRight: `1px solid ${borderColor}`,
                        borderBottom: `1px solid ${borderColor}`,
                        borderLeft: `1px solid ${borderColor}`,
                        boxSizing: 'border-box',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'normal',
                        fontWeight: 700,
                        textAlign: ['S.N.', 'Particulars'].includes(column?.key)
                          ? 'left'
                          : 'right',
                      }}
                    >
                      {column?.key}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {(type === 'contra' || type === 'journal') && (
            <>
              <div
                style={{
                  display: 'table',
                  width: '100%',
                  borderCollapse: 'collapse',
                }}
              >
                {voucherData.map((row, rowIndex) => {
                  // console.log('row', row);
                  return (
                    <div key={rowIndex} style={{ display: 'table-row' }}>
                      {columnsT.map((column) => (
                        <div
                          key={column.key}
                          style={{
                            display: 'table-cell',
                            width: `${column.width}%`,
                            padding: '7px',
                            borderRight: `1px solid ${borderColor}`,
                            borderBottom: `1px solid ${borderColor}`,
                            borderLeft: `1px solid ${borderColor}`,
                            textDecoration:
                              column.key === 'Debit' || column.key === 'Credit'
                                ? 'underline'
                                : '',
                            textAlign: [
                              'S.N.',
                              'Particulars',
                              'Account Name',
                              'Item Name',
                            ].includes(column.key)
                              ? 'left'
                              : 'right',
                          }}
                        >
                          {row?.[column?.dataIndex]}
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>

              <div
                style={{
                  display: 'table',
                  width: '100%',
                  // borderCollapse: 'collapse',
                }}
              >
                {voucherData2.map((row, rowIndex) => (
                  <div key={rowIndex} style={{ display: 'table-row' }}>
                    {columnsT.map((column) => (
                      <div
                        key={column.key}
                        style={{
                          display: 'table-cell',
                          width: `${column.width}%`,
                          padding: '7px',
                          borderRight: `1px solid ${borderColor}`,
                          borderBottom: `1px solid ${borderColor}`,
                          borderLeft: `1px solid ${borderColor}`,
                          fontWeight: 600,
                          textDecoration: 'underline',
                          textAlign: [
                            'S.N.',
                            'Particulars',
                            'Account Name',
                            'Item Name',
                          ].includes(column.key)
                            ? 'left'
                            : 'right',
                        }}
                      >
                        {row?.[column?.dataIndex]}
                      </div>
                    ))}
                  </div>
                ))}
              </div>

              <div
                style={{
                  textAlign: 'start',
                  padding: '20px 0',
                  fontWeight: 500,
                  fontSize: 14,
                  display: 'flex',
                }}
              >
                <div
                  style={{
                    paddingRight: '8px',
                  }}
                >
                  Long Narration :
                </div>
                <div
                  style={{
                    width: '60%',
                    borderBottom: `1px solid ${borderColor}`,
                  }}
                >
                  {data?.narration || ''}
                </div>
              </div>
              <div
                style={{
                  fontWeight: 600,
                  padding: '7px',
                  textAlign: 'start',
                  textTransform: 'uppercase',
                  borderTop: `1px solid ${borderColor}`,
                  borderLeft: `1px solid ${borderColor}`,
                  borderRight: `1px solid ${borderColor}`,
                  borderBottom: `1px solid ${borderColor}`,
                  overflowWrap: 'break-word',
                }}
              >
                {currencyType === '$' ? '$ ' : '[NPR]  '}
                {currencyType === '$'
                  ? toWordsUSD.convert(Number(totals.debitAmount?.toFixed(3)))
                  : toWords.convert(
                      Number((totals.debitAmount ?? 0).toFixed(3)),
                    )}
              </div>
            </>
          )}
        </div>
      ) : (
        <>
          <div
            style={{
              width: maxWidth - Number(data?.tablePaddingRight || 0),
              fontSize: config?.default_font_size || 12,
              minHeight: minHeight - 25,
              fontFamily: config?.default_font_family || 'Arial',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              borderLeft: `1px solid ${borderColor}`,
              borderRight: `1px solid ${borderColor}`,
              borderCollapse: 'collapse',
            }}
          >
            <div
              style={{
                display: 'table',
                borderCollapse: 'collapse',
                flex: 1,
                minHeight: 0,
                width: maxWidth - Number(data?.tablePaddingRight || 0),
              }}
            >
              {(type === 'purchase' ||
                type === 'purchase_return' ||
                type === 'sales' ||
                type === 'sales_return' ||
                type === 'receive_karigar' ||
                type === 'receive_party' ||
                type === 'receive_refine' ||
                type === 'issue_karigar' ||
                type === 'issue_refine' ||
                type === 'issue_party' ||
                type === 'sales_order' ||
                type === 'metal_transfer' ||
                type === 'metal_cash_payment' ||
                type === 'metal_cash_receipt' ||
                type === 'opening') && (
                <div
                  style={{
                    display: 'table-row',
                    backgroundColor: tableHeaderBgColor,
                    borderTop: `1px solid ${borderColor}`,
                  }}
                >
                  {isVisibleColumns
                    ?.sort((a, b) => a.order - b.order)
                    ?.map((column) => (
                      <div
                        key={column.key}
                        style={{
                          width: `${Number(column?.width || 0)}px`,
                          padding: '7px',
                          display: 'table-cell',
                          color: headerTextColor,
                          borderRight: `1px solid ${borderColor}`,
                          borderBottom: `1px solid ${borderColor}`,
                          boxSizing: 'border-box',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'normal',
                          fontWeight: 700,
                          textAlign: ['S.N.', 'Item Name'].includes(column?.key)
                            ? 'left'
                            : 'right',
                        }}
                      >
                        {column?.key}
                      </div>
                    ))}
                </div>
              )}
              {modifiedData?.map((item, rowIndex) => (
                <div
                  key={rowIndex}
                  style={{
                    display: 'table-row',
                  }}
                >
                  {isVisibleColumns
                    .sort((a, b) => a.order - b.order)
                    .map((column) => (
                      <div
                        key={column.key}
                        style={{
                          width: `${Number(column?.width || 0)}px`,
                          padding: '7px',
                          display: 'table-cell',
                          color: '#000000',
                          borderRight: `1px solid ${borderColor}`,
                          borderBottom: `1px solid ${borderColor}`,
                          boxSizing: 'border-box',
                          textAlign: ['S.N.', 'Item Name'].includes(column?.key)
                            ? 'left'
                            : 'right',
                        }}
                      >
                        {column.key === 'S.N.' ? (
                          rowIndex + 1
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              gap: '5px',
                              flexDirection: 'column',
                            }}
                          >
                            {item?.[column?.dataIndex]}
                            {column.dataIndex === 'itemName' &&
                              item?.images?.length > 0 && (
                                <div className="tw-grid tw-grid-cols-2 tw-gap-x-[2px]">
                                  {item.images.map(
                                    (
                                      imageItem: { image: string },
                                      index: number,
                                    ) => (
                                      <Image
                                        key={index}
                                        width={54}
                                        src={imageItem.image}
                                        style={{
                                          objectFit: 'contain',
                                          width: '100%',
                                          height: 'auto',
                                        }}
                                        alt={
                                          imageItem.image ||
                                          `Item image-${index}`
                                        }
                                      />
                                    ),
                                  )}
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              ))}
              <div style={{ display: 'table-row', height: '100%' }}>
                {isVisibleColumns
                  .slice()
                  .sort((a, b) => a.order - b.order)
                  .map((col) => (
                    <div
                      key={`filler-${col.key}`}
                      style={{
                        width: `${Number(col?.width || 0)}px`,
                        display: 'table-cell',
                        borderRight: `1px solid ${borderColor}`,
                        borderBottom: `1px solid ${borderColor}`,
                        height: '100%',
                        boxSizing: 'border-box',
                      }}
                    />
                  ))}
              </div>
            </div>

            {showTableFooter && (
              <div
                style={{
                  display: 'table',
                  width: maxWidth - Number(data?.tablePaddingRight || 0),
                  borderCollapse: 'collapse',
                  borderBottom: `1px solid ${borderColor}`,
                }}
              >
                {(type === 'purchase' ||
                  type === 'purchase_return' ||
                  type === 'sales' ||
                  type === 'sales_return' ||
                  type === 'receive_karigar' ||
                  type === 'receive_party' ||
                  type === 'receive_refine' ||
                  type === 'issue_karigar' ||
                  type === 'issue_refine' ||
                  type === 'issue_party' ||
                  type === 'sales_order' ||
                  type === 'metal_transfer' ||
                  type === 'metal_cash_payment' ||
                  type === 'metal_cash_receipt' ||
                  type === 'opening') && (
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        width: '100%',
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          minWidth: 0,
                          padding: '7px',
                          boxSizing: 'border-box',
                          verticalAlign: 'top',
                        }}
                      >
                        <div
                          style={{
                            fontWeight: 500,
                            display: 'flex',
                            flexWrap: 'wrap',
                            // textAlign: 'start',
                            // overflowWrap: 'break-word',
                          }}
                        >
                          <div
                            style={{
                              display: showGoldRate ? 'block' : 'none',
                            }}
                          >
                            Gold Rate in tola
                            {app?.primaryCalculationType?.toLowerCase() ===
                            'lal'
                              ? ''
                              : '( 11.664GMS )'}{' '}
                            :{' '}
                            <span className="tw-ms-2">
                              {currencyType === '$' ? 'AUD' : 'Rs.'}{' '}
                              {goldRateInTola() ||
                                data?.goldAmount?.toLocaleString() ||
                                0}
                            </span>
                          </div>
                          {/* {Number(data?.purchaseAmount ?? 0) > 0 &&
                          type === 'sales' && (
                            <div className="tw-w-[14rem]">
                              <span className="tw-font-medium tw-mr-1">
                                Total Purchase Amount:
                              </span>
                              <span className="tw-font-semibold">
                                Rs.&nbsp;
                                {Number(data?.purchaseAmount ?? 0)}
                              </span>
                            </div>
                          )} */}
                          {/* {Number(data?.adjustmentAmount ?? 0) > 0 &&
                          type === 'sales' && (
                            <div className="tw-w-[14rem]">
                              <span className="tw-font-medium tw-mr-1">
                                Total Adjustment Amount:
                              </span>
                              <span className="tw-font-semibold">
                                Rs.&nbsp;
                                {Number(data?.adjustmentAmount ?? 0)}
                              </span>
                            </div>
                          )} */}

                          {/* {Number(data?.receiveAmount ?? 0) > 0 &&
                          type === 'sales' && (
                            <div className="tw-w-[14rem]">
                              <span className="tw-font-medium tw-mr-1">
                                Receive From Party Amount:
                              </span>
                              <span className="tw-font-semibold">
                                Rs.&nbsp;
                                {Number(data?.receiveAmount ?? 0)}
                              </span>
                              <span className="tw-italic tw-ms-1">
                                using bill {data?.receiveBill}.
                              </span>
                              <span>
                                {' '}
                                (Pure Wt. : {data?.receivePureWeight})
                              </span>
                            </div>
                          )} */}
                          {/* {updatedVoucherData?.[0]?.receiveTo &&
                          type === 'sales' && (
                            <div className="tw-w-[20rem] tw-mt-1">
                              <span className="tw-font-medium">Receipt: </span>
                              <span className="tw-font-semibold">
                                Rs.{' '}
                                {formatNumberWithComma(
                                  Number(
                                    updatedVoucherData?.reduce(
                                      (acc: number, item: { amount: any }) =>
                                        acc + parseFloat(item?.amount || 0),
                                      0,
                                    ),
                                  ) || 0,
                                )}
                              </span>{' '}
                              made using voucher{' '}
                              <span className="tw-italic">
                                {data?.voucherData?.voucherNo}
                              </span>
                              .
                            </div>
                          )} */}
                        </div>
                        <div
                          className={`
                          ${caption ? 'tw-border-t tw-pt-1' : ''}`}
                          style={{
                            textAlign: 'start',
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                            wordBreak: 'break-word',
                          }}
                        >
                          {caption && (
                            <>
                              <span className="tw-font-bold">
                                {caption}
                              </span>{' '}
                            </>
                          )}
                          {caption && (
                            <>
                              <span className="tw-font-bold">
                                [{currencyType === '$' ? 'AUD' : 'NPR'}]
                              </span>
                              :{' '}
                            </>
                          )}
                          {caption && (
                            <>
                              {currencyType === '$'
                                ? toWordsUSD.convert(
                                    Number(data?.grandTotal ?? 0),
                                  )
                                : toWords.convert(
                                    Number(data?.grandTotal ?? 0),
                                  )}
                            </>
                          )}
                        </div>
                      </div>
                      {footerRightColumns.filter((item) => item.isVisible)
                        .length > 0 ? (
                        <div
                          style={{
                            flexShrink: 0,
                            verticalAlign: 'top',
                            borderRight: `1px solid ${borderColor}`,
                          }}
                        >
                          <div className="tw-flex tw-w-full tw-justify-end">
                            <div
                              style={{
                                display: 'table-cell',
                                verticalAlign: 'top',
                                borderCollapse: 'collapse',
                                width: 'fit-content',
                              }}
                            >
                              <div
                                className="tw-flex tw-flex-col tw-items-end tw-py-1 tw-px-1"
                                style={{
                                  overflowWrap: 'break-word',
                                }}
                              >
                                {Array.from(
                                  new Map(
                                    footerColumns
                                      .filter((item) => item.isVisible)
                                      .map((item) => [item.key, item]),
                                  ).values(),
                                )
                                  .sort((a, b) => a.order - b.order)
                                  .map((item, index) => {
                                    const value = (() => {
                                      switch (item.key) {
                                        case 'gross_total':
                                          return Number(data?.grossTotal ?? 0);
                                        case 'vat_amount':
                                          return Number(data?.vatAmount ?? 0);
                                        case 'discount':
                                          return Number(
                                            data?.discountAmount ?? 0,
                                          );
                                        case 'gold_rate':
                                          return Number(data?.goldAmount ?? 0);
                                        case 'grand_total':
                                          return Number(data?.grandTotal ?? 0);
                                        case 'purchase_amount':
                                          return Number(
                                            data?.purchaseAmount ?? 0,
                                          );
                                        case 'taxable_amount':
                                          return Number(
                                            data?.taxableAmount ?? 0,
                                          );
                                        case 'taxableAmount':
                                          return Number(
                                            data?.taxableAmount ?? 0,
                                          );
                                        case 'tax':
                                          return Number(data?.taxAmount ?? 0);
                                        case 'taxAmount':
                                          return Number(data?.taxAmount ?? 0);
                                        case 'tax_amount':
                                          return Number(data?.taxAmount ?? 0);
                                        case 'vatAmount':
                                          return Number(data?.vatAmount ?? 0);
                                        case 'balanceAmount':
                                          return Number(
                                            data?.balanceAmount ?? 0,
                                          );
                                        case 'agentName':
                                          return Number(data?.agentName ?? 0);
                                        default:
                                          return (
                                            data?.[
                                              item.key as keyof IBillContent
                                            ] ?? 0
                                          );
                                      }
                                    })();

                                    return (
                                      <div
                                        key={`${item.key}-${index}`}
                                        className="tw-flex tw-justify-between tw-w-full"
                                        style={{
                                          overflowWrap: 'break-word',
                                        }}
                                      >
                                        <span className="tw-font-semibold">
                                          {item.label}:
                                        </span>
                                        <span className="tw-font-semibold tw-px-[20px]">
                                          {currencyType === '$' ? '$' : 'Rs.'}{' '}
                                          {value.toLocaleString('en-US', {
                                            minimumFractionDigits: 3,
                                            maximumFractionDigits: 3,
                                          })}
                                        </span>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'table-cell',
                                verticalAlign: 'top',
                                borderCollapse: 'collapse',
                                width: 'fit-content',
                              }}
                            >
                              <div
                                className="tw-flex tw-flex-col tw-items-end tw-py-1 tw-px-1"
                                style={{
                                  overflowWrap: 'break-word',
                                }}
                              >
                                {Array.from(
                                  new Map(
                                    footerRightColumns
                                      .filter((item) => item.isVisible)
                                      .map((item) => [item.key, item]),
                                  ).values(),
                                )
                                  .sort((a, b) => a.order - b.order)
                                  .map((item, index) => {
                                    const value = (() => {
                                      switch (item.key) {
                                        case 'purchase_amount':
                                          return Number(
                                            data?.purchase_amount ?? 0,
                                          );
                                        case 'grand_total':
                                          return Number(data?.grandTotal ?? 0);
                                        case 'receipt_amount':
                                          return Number(
                                            data?.receiptAmount ?? 0,
                                          );
                                        case 'receiptAmount':
                                          return Number(
                                            data?.receiptAmount ?? 0,
                                          );
                                        case 'adjustment_amount':
                                          return Number(
                                            data?.adjustmentAmount ?? 0,
                                          );
                                        case 'balance_amount':
                                          return Number(data?.balanceAmount);
                                        case 'balanceAmount':
                                          return Number(data?.balanceAmount);

                                        default:
                                          return (
                                            data?.[
                                              item.key as keyof IBillContent
                                            ] ?? 0
                                          );
                                      }
                                    })();

                                    return (
                                      <div
                                        key={`${item.key}-${index}`}
                                        className="tw-flex tw-justify-between tw-w-full"
                                        style={{
                                          overflowWrap: 'break-word',
                                        }}
                                      >
                                        <span className="tw-font-semibold tw-px-[20px]">
                                          {item.label}:
                                        </span>
                                        <span className="tw-font-semibold">
                                          {currencyType === '$' ? '$' : 'Rs.'}{' '}
                                          {value.toLocaleString('en-US', {
                                            minimumFractionDigits: 3,
                                            maximumFractionDigits: 3,
                                          })}
                                        </span>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            flexShrink: 0,
                            verticalAlign: 'top',
                            borderRight: `1px solid ${borderColor}`,
                          }}
                        >
                          <div className="tw-flex tw-w-full tw-items-end tw-justify-end">
                            <div
                              className="tw-flex tw-flex-col tw-items-end tw-justify-end tw-py-1 tw-px-1 tw-w-fit"
                              style={{
                                overflowWrap: 'break-word',
                              }}
                            >
                              {Array.from(
                                new Map(
                                  footerColumns
                                    .filter((item) => item.isVisible)
                                    .map((item) => [item.key, item]),
                                ).values(),
                              )
                                .sort((a, b) => a.order - b.order)
                                .map((item, index) => {
                                  const value = (() => {
                                    switch (item.key) {
                                      case 'gross_total':
                                        return Number(data?.grossTotal || 0);
                                      case 'vat_amount':
                                        return Number(data?.vatAmount || 0);
                                      case 'adjustment_amount':
                                        return Number(
                                          data?.adjustmentAmount || 0,
                                        );
                                      case 'adjustmentAmount':
                                        return Number(
                                          data?.adjustmentAmount || 0,
                                        );
                                      case 'discount':
                                        return Number(
                                          data?.discountAmount || 0,
                                        );
                                      case 'gold_rate':
                                        return Number(data?.goldAmount || 0);
                                      case 'grand_total':
                                        return Number(data?.grandTotal ?? 0);
                                      case 'purchase_amount':
                                        return Number(
                                          data?.purchaseAmount ?? 0,
                                        );
                                      case 'taxable_amount':
                                        return Number(data?.taxableAmount ?? 0);
                                      case 'taxableAmount':
                                        return Number(data?.taxableAmount ?? 0);
                                      case 'tax_amount':
                                        return Number(data?.taxAmount ?? 0);
                                      case 'tax':
                                        return Number(data?.taxAmount ?? 0);
                                      case 'taxAmount':
                                        return Number(data?.taxAmount ?? 0);
                                      case 'vatAmount':
                                        return Number(data?.vatAmount ?? 0);
                                      case 'totalNetWeight':
                                        return Number(
                                          data?.totalNetWeight ?? 0,
                                        );
                                      case 'totalNetWithWastage':
                                        return Number(
                                          data?.totalNetWithWastage ?? 0,
                                        );
                                      case 'totalPureWeight':
                                        return Number(
                                          data?.totalPureWeight ?? 0,
                                        );
                                      case 'totalDiamondWeight':
                                        return Number(
                                          data?.totalDiamondWeight ?? 0,
                                        );
                                      case 'totalStoneWeight':
                                        return Number(
                                          data?.totalStoneWeight ?? 0,
                                        );
                                      case 'totalDiamondPcs':
                                        return Number(
                                          data?.totalDiamondPcs ?? 0,
                                        );
                                      case 'totalStonePcs':
                                        return Number(data?.totalStonePcs ?? 0);
                                      case 'totalDiamondAmount':
                                        return Number(
                                          data?.totalDiamondAmount ?? 0,
                                        );
                                      case 'totalStoneAmount':
                                        return Number(
                                          data?.totalStoneAmount ?? 0,
                                        );
                                      case 'balanceAmount':
                                        return Number(data?.balanceAmount ?? 0);
                                      default:
                                        return 0;
                                    }
                                  })();

                                  return (
                                    <div
                                      key={`${item.key}-${index}`}
                                      className="tw-flex tw-justify-between tw-w-full"
                                      style={{
                                        overflowWrap: 'break-word',
                                      }}
                                    >
                                      <span
                                        className="tw-font-semibold tw-px-[50px]"
                                        style={{
                                          marginRight:
                                            footerRightColumns.filter(
                                              (item) => item.isVisible,
                                            ).length > 0
                                              ? '0'
                                              : '20px',
                                        }}
                                      >
                                        {item.label}:
                                      </span>
                                      <span className="tw-font-semibold">
                                        {currencyFields.find(
                                          (f) => f.key === item.key,
                                        )?.isCurrency &&
                                          (currencyType === '$'
                                            ? '$'
                                            : 'Rs.')}{' '}
                                        {value.toLocaleString('en-US', {
                                          minimumFractionDigits: 3,
                                          maximumFractionDigits: 3,
                                        })}
                                      </span>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {type === 'sales' &&
              salesReceiptVoucherEntries?.length > 0 &&
              showReceiptDetails && (
                <>
                  <div
                    style={{
                      borderBottom: `1px solid ${borderColor}`,
                    }}
                  >
                    <div className="tw-font-semibold  tw-py-1 tw-px-2 tw-text-start">
                      Receipt Details
                    </div>
                    <div
                      style={{
                        display: 'table',
                        width: '100%',
                        borderCollapse: 'collapse',
                      }}
                    >
                      <div>
                        <div
                          style={{
                            display: 'table',
                            width: '100%',
                            borderCollapse: 'collapse',
                          }}
                        >
                          <div
                            style={{
                              display: 'table-row',
                              backgroundColor: tableHeaderBgColor,
                              borderTop: `1px solid ${borderColor}`,
                            }}
                          >
                            {[
                              {
                                key: 'Account Name',
                                width: 50,
                                dataIndex: 'ledgerName',
                              },
                              {
                                key: 'Amount [NPR]',
                                width: 20,
                                dataIndex: 'credit',
                              },
                              {
                                key: 'Short Narration',
                                width: 30,
                                dataIndex: 'remarks',
                              },
                            ]?.map((column) => (
                              <div
                                key={column.key}
                                style={{
                                  display: 'table-cell',
                                  width: `${Number(column?.width || 0)}%`,
                                  padding: '7px',
                                  borderRight: `1px solid ${borderColor}`,
                                  borderBottom: `1px solid ${borderColor}`,
                                  boxSizing: 'border-box',
                                  wordBreak: 'break-word',
                                  overflowWrap: 'break-word',
                                  whiteSpace: 'normal',
                                  fontWeight: 700,
                                  textAlign: [
                                    'S.N.',
                                    'Account Name',
                                    'Short Narration',
                                  ].includes(column?.key)
                                    ? 'left'
                                    : 'right',
                                }}
                              >
                                {column?.key}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <>
                        <div
                          style={{
                            display: 'table',
                            width: '100%',
                            borderCollapse: 'collapse',
                          }}
                        >
                          {salesReceiptVoucherEntries
                            ?.map((item: any) => {
                              return {
                                ...item,
                                creditAmount:
                                  Number(item?.creditAmount) ||
                                  Number(item?.debitAmount),
                              };
                            })
                            .map((row, rowIndex) => (
                              <div
                                key={rowIndex}
                                style={{ display: 'table-row' }}
                              >
                                {[
                                  {
                                    key: 'Account Name',
                                    width: 50,
                                    dataIndex: 'ledgerName',
                                  },
                                  {
                                    key: 'Amount [NPR]',
                                    width: 20,
                                    dataIndex: 'creditAmount',
                                  },
                                  {
                                    key: 'Short Narration',
                                    width: 30,
                                    dataIndex: 'remarks',
                                  },
                                ].map((column) => (
                                  <div
                                    key={column.key}
                                    style={{
                                      display: 'table-cell',
                                      width: `${column.width}%`,
                                      padding: '7px',
                                      borderRight: `1px solid ${borderColor}`,
                                      borderBottom: `1px solid ${borderColor}`,
                                      whiteSpace: 'wrap',
                                      textAlign: [
                                        'S.N.',
                                        'Account Name',
                                        'Short Narration',
                                      ].includes(column.key)
                                        ? 'left'
                                        : 'right',
                                    }}
                                  >
                                    {row?.[column?.dataIndex]}
                                  </div>
                                ))}
                              </div>
                            ))}
                        </div>
                      </>
                    </div>
                  </div>
                </>
              )}

            {type === 'purchase' &&
              salesReceiptVoucherEntries?.length > 0 &&
              showPaymentDetails && (
                <>
                  <div
                    style={{
                      borderBottom: `1px solid ${borderColor}`,
                    }}
                  >
                    <div className="tw-font-semibold  tw-py-2 tw-px-2 tw-text-start">
                      Payment Details
                    </div>
                    <div
                      style={{
                        display: 'table',
                        width: '100%',
                        borderCollapse: 'collapse',
                      }}
                    >
                      <div>
                        <div
                          style={{
                            display: 'table',
                            width: '100%',
                            borderCollapse: 'collapse',
                          }}
                        >
                          <div
                            style={{
                              display: 'table-row',
                              backgroundColor: tableHeaderBgColor,
                              borderTop: `1px solid ${borderColor}`,
                            }}
                          >
                            {[
                              {
                                key: 'Account Name',
                                width: 50,
                                dataIndex: 'ledgerName',
                              },
                              {
                                key: 'Amount [NPR]',
                                width: 20,
                                dataIndex: 'credit',
                              },
                              {
                                key: 'Short Narration',
                                width: 30,
                                dataIndex: 'remarks',
                              },
                            ]?.map((column) => (
                              <div
                                key={column.key}
                                style={{
                                  display: 'table-cell',
                                  width: `${Number(column?.width || 0)}%`,
                                  padding: '7px',
                                  borderRight: `1px solid ${borderColor}`,
                                  borderBottom: `1px solid ${borderColor}`,
                                  boxSizing: 'border-box',
                                  wordBreak: 'break-word',
                                  overflowWrap: 'break-word',
                                  whiteSpace: 'normal',
                                  fontWeight: 700,
                                  textAlign: [
                                    'S.N.',
                                    'Account Name',
                                    'Short Narration',
                                  ].includes(column?.key)
                                    ? 'left'
                                    : 'right',
                                }}
                              >
                                {column?.key}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <>
                        <div
                          style={{
                            display: 'table',
                            width: '100%',
                            borderCollapse: 'collapse',
                          }}
                        >
                          {salesReceiptVoucherEntries
                            ?.map((item: any) => {
                              return {
                                ...item,
                                creditAmount:
                                  Number(item?.creditAmount) ||
                                  Number(item?.debitAmount),
                              };
                            })
                            .map((row, rowIndex) => (
                              <div
                                key={rowIndex}
                                style={{ display: 'table-row' }}
                              >
                                {[
                                  {
                                    key: 'Account Name',
                                    width: 50,
                                    dataIndex: 'ledgerName',
                                  },
                                  {
                                    key: 'Amount [NPR]',
                                    width: 20,
                                    dataIndex: 'debitAmount',
                                  },
                                  {
                                    key: 'Short Narration',
                                    width: 30,
                                    dataIndex: 'remarks',
                                  },
                                ].map((column) => (
                                  <div
                                    key={column.key}
                                    style={{
                                      display: 'table-cell',
                                      width: `${column.width}%`,
                                      padding: '7px',
                                      borderRight: `1px solid ${borderColor}`,
                                      borderBottom: `1px solid ${borderColor}`,
                                      whiteSpace: 'wrap',
                                      textAlign: [
                                        'S.N.',
                                        'Account Name',
                                        'Short Narration',
                                      ].includes(column.key)
                                        ? 'left'
                                        : 'right',
                                    }}
                                  >
                                    {row?.[column?.dataIndex]}
                                  </div>
                                ))}
                              </div>
                            ))}
                        </div>
                      </>
                    </div>
                  </div>
                </>
              )}
          </div>
        </>
      )}
    </>
  );
};
